import moment from 'moment';
import{ NODE_TYPE_DELIVERABLE } from './constantes';

export function validateName(field){
    if(!(/^[a-z]+[ ]*[a-z]*[ ]*[a-z]*$/i.test(field)))
    {
        return false;
    }
    return true;
}

export function validateUsername(field){
    if(field.includes(" ")){
        return false;
    }
    return true;
}

export function validateField(field){
    if ((field != null) && !(typeof field==='undefined') && (field.length !== 0)) {
        return true;
    }
    return false;
}


export function validateDecimalNumberWithLimit(field, limit = 9)
{
    
    // let re = new RegExp("[1-9]\d{1,"+(limit-1)+"}$","g");
    let re = new RegExp("^[0-9]{1,"+limit+"}([.][0-9]{1,2})?$", "g");
    return re.test(field);
}

export function validateIntegerNumberWithLimit(field, limit = 9){
  // let re = /^[1-9]\d{3,8}$/
  let re = new RegExp("^[0-9]{1,"+limit+"}$", "g");
  return re.test(field);
}

export function validateDecimalNumber(field, limit = 9){
    let re = /^[1-9]\d{0,10}(\.\d{0,2})*(,\d+)?$/
    return re.test(field);
}

export function validateIntegerNumber(field, limit = 9){
    let re = /^[1-9]\d{3,8}$/
    return re.test(field);
}

export function validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


export function validateDates(first_date, second_date, operator){
    var momentA = moment(first_date);
    var momentB = moment(second_date);
    if(!momentA.isValid() || !momentB.isValid())
      return false;
    switch(operator){
        case 1: //Mayor
            return momentA > momentB;
        case 2: //Menor
            return momentA < momentB;
        case 3: //Igual
            return momentA === momentB;
        case 4: //Mayor o igual
            return momentA >= momentB;
        case 5: //Menor o igual
            return momentA <= momentB;
        default:
            return false;
    }
}



  /*Valid a especific node */
export function WBS_isNodeValid(node)
  {
    if(node.tipo === NODE_TYPE_DELIVERABLE)
    {
      //Si el tipo del nodo es entregable y no tiene hijos es inválido
      return node.children && node.children.length>0;
    }
    else
    {
      if(node.children && node.children.length > 0)
      {
        //Si tiene varios hijos, hacemos que todos los hijos sean validos sino no es valido el actual componente.
        let valid = true;
        node.children.forEach(item=>{
          valid = valid && WBS_isNodeValid(item);
        });
        return valid;
      }
      else
      {
        //Si no tiene hijos entonces es inválido el componente.
        return false;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/features/common/redux/validators.js